module.exports = __webpack_public_path__ + "media/images/pic/podskakujaca-dziewczynka-9d85a776d60d34727f26c8f612738b02.webp";